<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
  <path
    fill="currentColor"
    d="m4.67 8.418 5.834 5.909c.228.23.597.23.825 0a.596.596 0 0 0 0-.836l-5.42-5.49 5.42-5.492a.596.596 0 0 0 0-.836.577.577 0 0 0-.825 0l-5.833 5.91a.595.595 0 0 0 0 .835Z"
  />
</svg>
